import { library } from "@fortawesome/fontawesome-svg-core";

import { faCircleUser } from "@fortawesome/sharp-regular-svg-icons";

export const initSharpIcons = () => {
  library.add(faCircleUser);
};
